import clientInformation, { getClientItem } from '../login/ClientInfo';
import { RequestBankWirePayout } from "../../services/PayoutService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, GetCustomerInfo, GetCountries, GetStatesbyCountry } from "../../services/AuthenticationService";
import BeatLoader from "react-spinners/BeatLoader";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';
import { Button, Collapse } from 'react-bootstrap'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

export const PayoutWireTransferMethods = () => {
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(getClientItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID === id; })[0]);
    const navigate = useNavigate();
    const [arrayCustomerInfo, setArrayCustomerInfo] = useState([]);
    const [showComponent, setshowComponent] = useState(false);
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const [arrayCountries, setArrayCountries] = useState([]);
    const [arrayStates, setArrayStates] = useState([]);
    const [arrayCorrStates, setArrayCorrStates] = useState([]);
    const [stateCode, setStateCode] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [bankCountry, setBankCountry] = useState('');
    const [bankState, setBankState] = useState('');
    const [corrCountry, setCorrCountry] = useState('');
    const [corrState, setCorrState] = useState('');
    const [othForm, setOthForm] = useState({ CheckTypes: '' });
    const [open, setOpen] = useState(false);
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(async function (response) {
            await GetCountries(getClientItem('Token')).then(async function (response) {
                var i = 0;
                const filtered = response.Authentication.map(item => {
                    const {
                        Code,
                        Name } = item;

                    return { Key: i++, Code, Name }
                });
                setArrayCountries(filtered);
                setBankCountry('US');
                setCorrCountry('US');
                handleStatebyCountry('US', true);
                handleCurrStatebyCountry('US', true);
            });
        })
            .catch(function (error) {
                navigate('/expired/');
            })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }
        CustomerInfo();

    }, [])

    async function CustomerInfo() {
        await GetCustomerInfo(getClientItem('Token')).then(function (response) {
            if (response.Authentication.ErrorDescription != "Invalid input data") {
                setArrayCustomerInfo(response.Authentication);

            }
            else {

                Alerts.ShowAlert('Error', 'Error getting customer info: ' + response.Authentication.ErrorDescription, 'error');

            }
        })
            .catch(function (error) {

                Alerts.ShowAlert('Error', 'Error getting customer info: ' + error.response.data.Authentication.ErrorDescription, 'error');
            })
    }

    const handleStatebyCountry = async (selectedCountryCode, setState) => {
        await GetStatesbyCountry(selectedCountryCode).then(async function (response) {
            var i = 0;
            const filtered = response.Authentication.map(item => {
                const {
                    Code,
                    Name } = item;

                return { Key: i++, Code, Name }
            });
            setArrayStates(filtered);
            if (setState) {
                if (filtered.length > 1)
                    setBankState(filtered[1].Code);
                else
                    setBankState(filtered[0].Code);
            }
        })
    }
    const handleCurrStatebyCountry = async (selectedCountryCode, setState) => {
        await GetStatesbyCountry(selectedCountryCode).then(async function (response) {
            var i = 0;
            const filtered = response.Authentication.map(item => {
                const {
                    Code,
                    Name } = item;

                return { Key: i++, Code, Name }
            });
            setArrayCorrStates(filtered);
            if (setState) {
                if (filtered.length > 1)
                    setCorrState(filtered[1].Code);
                else
                    setCorrState(filtered[0].Code);
            }
        })
    }
    async function doRequestBankWirePayout(Amount, accountnumber, swift, bankname, bankstate, bankcity, bankcountry, bankzip, bankaddress, corraccount, corraddress1, corrbank, corrcity, corrcountry, corrstate, corrswift, corrzip, comments) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) < parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {
            var PayoutData = {
                "Token": getClientItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": clientInfo.CurrencyCode,
                "ProcessorName": arrayPayouts?.PayoutID,
                "IPv4Address": clientInfo.IPAddress,
                "Comments": comments,
                "Swift": swift,
                "AccountNumber": accountnumber,
                "BankName": bankname,
                "BankCity": bankcity,
                "BankState": bankstate,
                "BankCountry": bankcountry,
                "BankZip": bankzip,
                "BankAddress": bankaddress,
                "CorrAccount": corraccount,
                "CorrAddress1": corraddress1,
                "CorrAddress2": '',
                "CorrBank": corrbank,
                "CorrCity": corrcity,
                "CorrCountry": corrcountry,
                "CorrState": corrstate,
                "CorrSwift": corrswift,
                "CorrZip": corrzip
            };

            await RequestBankWirePayout(PayoutData).then(function (response) {

                try {
                    var payload = {
                        TransactionID: response.Authentication.TransactionID,
                        Amount: amount,
                        Status: response.Authentication.Status,
                        ProcessorName: arrayPayouts?.PayoutID
                    }

                    window.parent.postMessage(
                        { 'transactionInfo': payload },
                        '*'
                    );
                }
                catch (error) { }

                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Withdrawal Status', response.Authentication.HtmlResponse, 'info');
                    else
                        Alerts.ShowAlert('Withdrawal Status', response.Authentication.HtmlResponse, 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen('Withdrawal Status', response.Authentication.HtmlResponse, 'warning');
                    else
                        Alerts.ShowAlert('Withdrawal Status', response.Authentication.HtmlResponse, 'warning');
                }
            })
                .catch(function (error) {
                    Alerts.ShowAlert('Withdrawal Status', error.response.data.Authentication.HtmlResponse, 'error');
                    //Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen('Withdrawal Status', 'amount not permitted, please check your withdrawal balance', 'warning');
            else
                Alerts.ShowAlert('Withdrawal Status', 'amount not permitted, please check your withdrawal balance', 'warning');
        }

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, accountnumber, swift, bankname, bankcity, bankcountry, bankaddress, bankstate, corraddress1, corrbank, corrcity, corrcountry, corrstate,  corrswift } = Object.fromEntries(data.entries());

            if (amount != '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                await doRequestBankWirePayout(amount, accountnumber, swift, bankname, bankstate, bankcity, bankcountry, '', bankaddress, '', corraddress1, corrbank, corrcity, corrcountry, corrstate, corrswift, '', '');
                setIsProcessing(false);


            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }

        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayPayouts?.ImageName + ".svg"} />  <span className="payout-title">Withdraw using {arrayPayouts?.PayoutID} </span>
                    </span>
                </div>
                <div className="row">
                    {/*First Name*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="firstname" className=" col-sm-12">First Name:</label>
                        <input type="text" className="form-control" id="firstname" aria-describedby="firstname" placeholder="first name" name="firstname" required="required" value={arrayCustomerInfo.Name} />
                    </div>
                    {/*Last Name*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="lastname" className="col-sm-12">Last name:</label>
                        <input type="text" className="form-control" id="lastname" aria-describedby="lastname" placeholder="last name" name="lastname" required="required" value={arrayCustomerInfo.LastName} />
                    </div>
                    {/*Phone Number*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="telephone" className=" col-sm-12">Phone Number:</label>
                        <input type="number" className="form-control" id="telephone" aria-describedby="telephone" placeholder="phone #" name="telephone" required="required" value={arrayCustomerInfo.Phone} />
                    </div>
                </div>
                <div className="row">
                    {/*Country*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="country" className="col-sm-12">Country:</label>
                        <input type="text" className="form-control color-gray border-teal" name="country" aria-label="country" value={arrayCustomerInfo.Country} placeholder={arrayCustomerInfo.Country == '' ? "Country" : arrayCustomerInfo.Country} disabled="disabled" />
                    </div>
                    {/*State*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="state" className=" col-sm-12">State:</label>
                        <input type="text" className="form-control color-gray border-teal" name="state" aria-label="state" value={arrayCustomerInfo.State} placeholder={arrayCustomerInfo.State == '' ? "State / Prov" : arrayCustomerInfo.State} disabled="disabled" />
                    </div>
                    {/*Amount*/}
                    <div className="col-md-4 col-sm-12 m3 mb-4">
                        <label for="ccCurrency" className="col-sm-12">Amount:</label>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                    <select className="form-control selectcurrency" disabled name="ccCurrency" required value={clientInfo.CurrencyCode}>
                                        <option value="" className="">Currency</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </span>
                            </div>
                            <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Amount" max={arrayPayouts?.MaxPayout === 0 ? MAXLIMIT : arrayPayouts?.MaxPayout} min={arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} name="amount" required="required" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0}/>
                        </div>

                        <div className="d-flex flex-row ml-2 limit-text-center" style={{ marginBottom: '4px' }}>
                            PayoutLimits: Minimum {arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} USD Maximum {arrayPayouts?.MaxPayout === 0 ? 'No Limit' : arrayPayouts?.MaxPayout + ' USD'}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-title-color mb-4 mt-5">
                        <h3>Beneficiary Bank information</h3>
                    </div>
                </div>
                <div className="row">
                    {/*Account Number*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="accountnumber" className="col-sm-12">Account Number:</label>
                        <input type="text" className="form-control" id="accountnumber" aria-describedby="accountnumber" placeholder="Account Number" name="accountnumber" required="required" />
                    </div>
                    {/*Swift*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="swift" className="col-sm-12">Swift Code:</label>
                        <input type="text" className="form-control" id="swift" aria-describedby="swift" placeholder="Swift Code" name="swift" maxLength="11" required="required" />
                    </div>
                    {/*Bank Name*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankname" className=" col-sm-12">Bank name:</label>
                        <input type="text" className="form-control" id="bankname" aria-describedby="bankname" placeholder="bank name" name="bankname" required="required" />
                    </div>
                    {/*Bank Country*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankcountry" className="col-sm-12">Bank Country:</label>
                        <select id="bankcountry" name="bankcountry" className="form-select border-teal" value={bankCountry} onChange={(event) => { setBankCountry(event.target.value); handleStatebyCountry(event.target.value, true) }} disabled="disabled"
                            tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the Country" required >
                            {arrayCountries.map((item) => <option key={item.Key} value={item.Code}>{item.Name}</option>
                            )}
                        </select>
                        <input type="hidden" name="bankcountry" value={bankCountry} />
                    </div>
                    {/*Bank State*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankstate" className="col-sm-12">Bank State:</label>
                        <select id="bankstate" name="bankstate" className="form-select border-teal" value={bankState} onChange={(event) => { setBankState(event.target.value); }}
                            tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the State" required >
                            {arrayStates.map((item) => <option key={item.Key} value={item.Code}>{item.Name}</option>
                            )}
                        </select>
                    </div>
                    {/*Bank City*/}
                    <div className="col-md-4 col-sm-12 mb-3">
                        <label for="bankcity" className=" col-sm-12">Bank City:</label>
                        <input type="text" className="form-control" id="bankcity" aria-describedby="bankcity" placeholder="bank city" name="bankcity" required="required" />
                    </div>
                </div>
                <div className="row">
                    {/*Bank Address*/}
                    <div className="col-md-8 col-sm-12 mb-3">
                        <label for="bankaddress" className=" col-sm-12">Bank Address:</label>
                        <input type="text" className="form-control" id="bankaddress" aria-describedby="bankaddress" placeholder="bank address" name="bankaddress" required="required" />
                    </div>
                </div>
                <div className="row" >
                    <div className="col-md-9 mb-4 mt-5">
                        <Button
                            variant="link"
                            onClick={() => setOpen(!open)}
                            aria-expanded={open}
                            aria-controls="collapseID"
                        >
                            Intermediary Bank information <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    </div>
                </div>
                <Collapse in={open}>
                    <div className="row">
                        {/*Swift*/}
                        <div className="col-md-4 col-sm-12 mb-3">
                            <label for="corrswift" className="col-sm-12">Swift Code:</label>
                            <input type="text" className="form-control" id="corrswift" aria-describedby="corrswift" placeholder="Swift Code" name="corrswift" maxLength="11" />
                        </div>
                        {/*Bank Name*/}
                        <div className="col-md-4 col-sm-12 mb-3">
                            <label for="corrbank" className=" col-sm-12">Bank name:</label>
                            <input type="text" className="form-control" id="corrbank" aria-describedby="corrbank" placeholder="bank name" name="corrbank" />
                        </div>
                        {/*Bank Country*/}
                        <div className="col-md-4 col-sm-12 mb-3">
                            <label for="corrcountry" className="col-sm-12">Bank Country:</label>
                            <select id="corrcountry" name="corrcountry" className="form-select border-teal" value={corrCountry} onChange={(event) => { setCorrCountry(event.target.value); handleCurrStatebyCountry(event.target.value, true) }} disabled="disabled"
                                tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the Country"  >
                                {arrayCountries.map((item) => <option key={item.Key} value={item.Code}>{item.Name}</option>
                                )}
                            </select>
                            <input type="hidden" name="corrcountry" value={corrCountry} />
                        </div>
                        {/*Bank State*/}
                        <div className="col-md-4 col-sm-12 mb-3">
                            <label for="corrstate" className="col-sm-12">Bank State:</label>
                            <select id="corrstate" name="corrstate" className="form-select border-teal" value={corrState} onChange={(event) => { setCorrState(event.target.value); }}
                                tooltip-placement="bottom" tooltip-trigger="focus" tooltip-class="customClass" uib-tooltip="Select the State"  >
                                {arrayCorrStates.map((item) => <option key={item.Key} value={item.Code}>{item.Name}</option>
                                )}
                            </select>
                        </div>
                        {/*Bank City*/}
                        <div className="col-md-4 col-sm-12 mb-3">
                            <label for="corrcity" className=" col-sm-12">Bank City:</label>
                            <input type="text" className="form-control" id="corrcity" aria-describedby="corrcity" placeholder="bank city" name="corrcity"  />
                        </div>
                        {/*Bank Address*/}
                        <div className="col-md-8 col-sm-12 mb-3">
                            <label for="corraddress1" className=" col-sm-12">Bank Address:</label>
                            <input type="text" className="form-control" id="corraddress1" aria-describedby="corraddress1" placeholder="bank address" name="corraddress1" />
                        </div>
                    </div>
                </Collapse>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>BACK</button>
                        <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">SUBMIT</button>
                    </div>
                </div>


            </form>
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>
    );

}